import { render, staticRenderFns } from "./HomeLeft.vue?vue&type=template&id=0acd197a"
import script from "./HomeLeft.vue?vue&type=script&lang=js"
export * from "./HomeLeft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports